const baseURL = process.env.REACT_APP_URL;

export const BASE_URL = `${baseURL}/api/WebServiceForStaffData.aspx`;
export const GRATUITY_URL = `${baseURL}/api/WebServiceCommonReports.aspx`;
export const SALARY_SUMMARY_URL = `${baseURL}/api/WebServiceMonthlyReports.aspx`;
export const BONUS_REPORT_URL = `${baseURL}/api/WebServiceBonusReports.aspx`;
export const FORM_URL = `${baseURL}/api/WebServiceFactoryReports.aspx`;
export const EMPLOYEE_URL = `${baseURL}/api/WebServiceEmployeeForms.aspx`;
export const ATTENDANCE_URL = `${baseURL}/api/WebServiceAttReports.aspx`;
export const PFYEARLYREPORT_URL = `${baseURL}/api/WebServiceYearlyPFESIReports.aspx`;
